import React, { FC, useMemo } from 'react';
import { ReportsNestedTableBodyCont } from './ReportsNestedTableBody.styles';
import { IItemReportResponse } from '../../../../services/reports';
import ReportsNestedTableTile from '../ReportsNestedTableTile/ReportsNestedTableTile';

interface IReportsNestedTableBody {
  items: IItemReportResponse[];
  surveyType: string;
}

const ReportsNestedTableBody: FC<IReportsNestedTableBody> = ({ items, surveyType }) => {
  const renderItems = useMemo(() => {
    return items.map((item: IItemReportResponse) => (
      <ReportsNestedTableTile item={item} key={item.id} surveyType={surveyType} />
    ));
  }, [items]);

  return (
    <ReportsNestedTableBodyCont id="ReportsNestedTableBodyCont">
      {renderItems}
    </ReportsNestedTableBodyCont>
  );
};

export default ReportsNestedTableBody;
